// Shared brand tokens + asset URLs used across the public site.

export const LEGACY = process.env.REACT_APP_LEGACY_URL || 'https://www.getsquarefare.com';

export const COLORS = {
  dark: '#33343b',     // legacy charcoal (headings, buttons, nav text)
  cream: '#fffcf6',    // legacy header/page cream
  creamAlt: '#efe6de', // legacy warm beige for section bands & cards
  orange: '#f9a826',   // legacy CTA orange
  text: '#43444b',
  muted: '#77787f',
};

export const FONTS = {
  serif: "'Playfair Display', Georgia, 'Times New Roman', serif",
  sans: "'Lato', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
};

// The legacy site sets headings at Playfair 400 / 1.4em; the taller, thinner
// treatment is the brand. Spread this instead of setting fontFamily by hand.
export const HEADING = {
  fontFamily: FONTS.serif,
  fontWeight: 400,
  lineHeight: 1.4,
};

// One type scale for every public marketing page, hand-built or block-rendered.
export const TYPE = {
  heroTitle: 'clamp(45px, 5.6vw, 98px)',
  heroEyebrow: '16px',
  sectionHeading: '45px',  // centered section titles: heading, steps, cards, ctaGroup
  sectionHeadingLg: 'clamp(45px, 4.4vw, 62px)',  // columns marked size: 'lg'
  // Left-aligned editorial bands, where the title anchors the left margin.
  displayHeading: 'clamp(36px, 3.8vw, 58px)',
  bandHeading: '30px',     // headings inside two-column bands: imageText, split
  subHeading: '26px',      // headings within running copy: text, list
  cardTitle: '23px',
  cardPrice: '20px',
  faqQuestion: '22px',     // accordion question rows on the FAQs page

  quoteName: '23px',
  quote: '22px',
  body: '18px',
  bodyLg: '26px',          // columns marked size: 'lg'
  bodySm: '16px',          // card lines, blurbs, quote attribution
  button: '16px',
};

// Images live under /public/images, foldered by the section that uses them;
// anything used by more than one section sits in /images/shared.
const IMAGES = `${process.env.PUBLIC_URL || ''}/images`;
export const IMG = {
  heroChef: `${IMAGES}/home/hero-chef.webp`,
  mission: `${IMAGES}/home/mission.webp`,
  science: `${IMAGES}/home/science.webp`,
  homeVeggies: `${IMAGES}/home/veggies.webp`,

  aboutBanner: `${IMAGES}/about/banner.webp`,
  aboutMission: `${IMAGES}/about/mission.webp`,
  aboutDelivery: `${IMAGES}/about/delivery.webp`,
  aboutClaire: `${IMAGES}/about/claire.webp`,
  aboutApproachNutrition: `${IMAGES}/about/approach-nutrition.webp`,
  aboutApproachMenus: `${IMAGES}/about/approach-menus.webp`,
  aboutApproachFood: `${IMAGES}/about/approach-food.webp`,
  aboutPhilosophy: `${IMAGES}/about/philosophy.webp`,
  aboutSustainBeets: `${IMAGES}/about/sustainability-beets.webp`,
  aboutSustainCrops: `${IMAGES}/about/sustainability-crops.webp`,
  aboutSustainMarket: `${IMAGES}/about/sustainability-market.webp`,
  aboutNewsletter: `${IMAGES}/about/newsletter.webp`,

  htoBanner: `${IMAGES}/how-to-order/banner.webp`,
  htoStep1: `${IMAGES}/shared/order-step-1.webp`,
  htoStep3: `${IMAGES}/shared/order-step-3.webp`,
  // One salad-bowls photo, shared by three places.
  menu: `${IMAGES}/shared/salad-bowls.webp`,
  htoStep2: `${IMAGES}/shared/order-step-2.webp`,
};

// Handouts served straight from /public rather than the legacy site.
export const DOCS = {
  aboutGuide: `${process.env.PUBLIC_URL || ''}/docs/about-square-fare.pdf`,
};

export const NAV_GROUPS = [
  {
    label: 'Order',
    items: [
      { label: 'How To Order', to: '/how-to-order' },
      { label: 'Subscriptions', href: `${LEGACY}/prepared-meal-subscription` },
      { label: "This Week's Menu", to: '/this-weeks-menu' },
      { label: 'GLP-1 Meal Program', to: '/glp1-meal-plan' },
      { label: 'The Bridal Cut', to: '/the-bridal-cut' },
      { label: 'Catering', to: '/catering' },
      { label: 'For Children', to: '/daycare' },
      { label: 'For Runners', to: '/meal-plans-for-runners' },
      // For Pros is password-protected on Squarespace, so there was no content
      // to port — link straight through to the gated page instead. "For
      // Students" is gated too and stays unlinked.
      { label: 'For Pros', href: `${LEGACY}/for-pros` },
    ],
  },
  {
    label: 'Contact Us',
    items: [
      { label: 'For Dietitians & Nutritionists', to: '/nutritionists' },
      { label: 'For Fitness Trainers', to: '/trainers' },
      { label: 'Be A Partner', to: '/contact-form-partners' },
      { label: 'Contact Form', to: '/contact-form-general' },
    ],
  },
  {
    label: 'About',
    items: [
      { label: 'About Us', to: '/about' },
      { label: 'The Science', to: '/science' },
      { label: 'What We Help With', to: '/health-goals' },
      { label: 'Experts We Support', to: '/experts' },
      { label: 'FAQ', to: '/faqs' },
    ],
  },
];
